import React, { useEffect, useState } from 'react';
import { getEmojiDataFromNative } from 'emoji-mart';

import { getFromLocalStorage } from 'widget/actions';
import { Icons, Text } from 'widget/components';
import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useMsgContext } from '../msg-context';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

interface EmojiMartFrequently {
  [index: string]: number;
}

interface ReactionTrigger {
  isContextMenuActive: boolean;
  setIsContextMenuActive: Env.SetState<boolean>;
  setIsReactionPickerActive: Env.SetState<boolean>;
}

const initialReactions = ['❤', '👌', '👍'];

const ReactionTrigger = ({
  isContextMenuActive,
  setIsContextMenuActive,
  setIsReactionPickerActive,
}: ReactionTrigger) => {
  const { widget } = useWidgetContext();
  const { sendReaction } = useChatBodyContext();
  const { msg } = useMsgContext();

  const [reactions, setReactions] = useState(initialReactions);

  const getReactions = async () => {
    const emojiMartFrequently = getFromLocalStorage<EmojiMartFrequently>(
      'emoji-mart.frequently',
    );

    if (!emojiMartFrequently) return;
    else if (typeof emojiMartFrequently == 'string') return;

    const keys = Object.keys(emojiMartFrequently)
      .sort((a, b) => emojiMartFrequently[b] - emojiMartFrequently[a])
      .slice(0, 3);

    const frequently: string[] = [];

    const promises = keys.map(async key => {
      const emoji = await getEmojiDataFromNative(key);
      frequently.push(emoji.native);
    });

    await Promise.all(promises);
    setReactions(frequently);
  };

  useEffect(() => {
    if (!isContextMenuActive) return;
    getReactions();
  }, [isContextMenuActive]);

  const handleClick = (reaction: string) => {
    sendReaction(msg.id, reaction);
    setIsContextMenuActive(false);
  };

  const handleTrigger = () => {
    setIsContextMenuActive(false);
    setIsReactionPickerActive(true);
  };

  return (
    <div className="whatcrm-widget-reaction-trigger">
      {reactions.map((reaction, i) => (
        <div
          className="whatcrm-widget-reaction-trigger__item"
          key={i}
          onClick={() => handleClick(reaction)}
        >
          <Text fontSize={24}>{reaction}</Text>
        </div>
      ))}

      <button
        className="whatcrm-widget-reaction-trigger__btn"
        onClick={handleTrigger}
      >
        <Icons.CaretDown
          fill={widget.theme == 'dark' ? 'white' : 'dark'}
          size={16}
        />
      </button>
    </div>
  );
};

export default ReactionTrigger;
